import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { HiMail, HiLockClosed } from 'react-icons/hi';

const API = process.env.REACT_APP_API_URL;

const HERO_SLIDES = [
  '/images/wavvy.jpeg',
  '/images/wavvyone.jpeg',
  '/images/wavvytwo.jpeg',
];

export default function SiteLockGate({ showLock, children }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Email signup
  const [email, setEmail] = useState('');
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [subscribing, setSubscribing] = useState(false);

  // Slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || subscribing) return;

    setEmailError('');
    setSubscribing(true);

    try {
      await axios.post(`${API}/api/newsletter/subscribe`, { email });
      setEmailSubmitted(true);
    } catch (err) {
      setEmailError('Failed to subscribe. Please try again.');
    } finally {
      setSubscribing(false);
    }
  };

  if (showLock) {
    return (
      <div className="min-h-screen relative overflow-hidden bg-black">
        {/* Slideshow background */}
        {HERO_SLIDES.map((slide, index) => (
          <div
            key={index}
            className="absolute inset-0 bg-cover bg-center transition-opacity duration-[2000ms] ease-in-out"
            style={{
              backgroundImage: `url('${slide}')`,
              opacity: index === currentSlide ? 1 : 0,
            }}
          />
        ))}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]" />

        <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4">
          {/* Glassmorphism card */}
          <div className="w-full max-w-lg bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 md:p-10 shadow-2xl text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 rounded-full mb-6">
              <HiLockClosed className="text-white text-xl" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">
              WAVEYYENT
            </h1>
            <p className="text-white/70 text-lg mb-8 max-w-sm mx-auto">
              We’re preparing something exclusive.
              <br />Join the list to be the first to know when we drop.
            </p>

            {/* Email form */}
            {!emailSubmitted ? (
              <form onSubmit={handleEmailSubmit} className="space-y-4">
                <div className="relative">
                  <HiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50 text-lg" />
                  <input
                    type="email"
                    placeholder="Your email"
                    className="w-full pl-12 pr-4 py-4 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/50 focus:outline-none focus:border-white/60 transition"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={subscribing}
                  className="w-full py-4 bg-white text-black font-semibold rounded-xl hover:bg-gray-200 transition disabled:opacity-50"
                >
                  {subscribing ? 'Subscribing…' : 'Notify Me'}
                </button>
                {emailError && <p className="text-red-400 text-sm mt-2">{emailError}</p>}
              </form>
            ) : (
              <p className="text-green-400 font-medium">You’re on the list! We’ll email you when we drop.</p>
            )}

            {/* Password access link */}
            <div className="mt-6 pt-4 border-t border-white/20">
              <Link
                to="/password-access"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white transition text-sm font-medium"
              >
                <HiLockClosed className="text-base" />
                Already have a password? Enter here
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
}